<template>
  <div>
    <el-descriptions :column="3" size="mini" border>
      <el-descriptions-item label="流程名称">
        <el-input size="mini" style="width: 200px;" v-model="form.name"></el-input>
      </el-descriptions-item>
      <el-descriptions-item label="操作">
        <el-button @click="ERP.navigateBack()">返回</el-button>
        <el-button type="primary" @click="saveFlowSheet()" >保 存</el-button>
      </el-descriptions-item>
    </el-descriptions>
    <div class="logic-flow-view">
      <!--    <h3 class="demo-title">LogicFlow Vue demo</h3>-->
      <!-- 辅助工具栏 -->
      <Control
        class="demo-control"
        v-if="lf"
        :lf="lf"
        :catTurboData="false"
        @catData="$_catData"
        @catTurboData="$_catTurboData"
        @onEvent="$_onEventControl"
      ></Control>
      <!-- 节点面板 -->
      <NodePanel v-if="lf" :lf="lf" :nodeList="nodeList"></NodePanel>
      <!-- 画布 -->
      <div id="LF-view" ref="container"></div>
      <!-- 用户节点自定义操作面板 -->
      <AddPanel
        v-if="showAddPanel"
        class="add-panel"
        :style="addPanelStyle"
        :lf="lf"
        :nodeData="addClickNode"
        @addNodeFinish="hideAddPanel"
      >
      </AddPanel>
      <div class="panel-property">
        <el-collapse accordion value="property">
          <el-collapse-item name="property">
            <template slot="title">
              &nbsp;&nbsp;&nbsp;&nbsp;属性 <i class="header-icon el-icon-info"></i>
            </template>
            <PropertyDialog
              v-if="dialogVisible"
              :nodeData="clickNode"
              :lf="lf"
              @setPropertiesFinish="closeDialog"
            ></PropertyDialog>
          </el-collapse-item>
        </el-collapse>
      </div>
      <!-- 数据查看面板 -->
      <el-dialog
        title="数据"
        :visible.sync="dataVisible"
        width="50%">
        <el-input
          type="textarea"
          :rows="20"
          placeholder="请输入内容"
          :value="JSON.stringify(graphData,'',4)" @change="importData">
        </el-input>
      </el-dialog>

      <el-dialog
        title="数据"
        :visible.sync="dataVisible2"
        width="50%">
        <FlowPathPanel v-if="dataVisible2" :flow_path="flow_path" />
      </el-dialog>
    </div>
  </div>
</template>
<script>
import LogicFlow from '@logicflow/core'
import { Menu, Snapshot, MiniMap } from '@logicflow/extension'
import '@logicflow/core/dist/style/index.css'
import '@logicflow/extension/lib/style/index.css'
import NodePanel from '@/components/Admin/Flow/bpmn/LFComponents/NodePanel'
import AddPanel from '@/components/Admin/Flow/bpmn/LFComponents/AddPanel'
import Control from '@/components/Admin/Flow/bpmn/LFComponents/Control'
import PropertyDialog from '@/components/Admin/Flow/bpmn/PropertySetting/PropertyDialog'
import { nodeList } from '@/components/Admin/Flow/bpmn/config'

import { ContextPad } from "@/components/Admin/Flow/bpmn/pad/ContextPad";
import setContextPad from "@/components/Admin/Flow/bpmn/pad/setContextPad";

import {
  registerStart,
  registerUser,
  registerEnd,
  registerPush,
  registerDownload,
  registerPolyline,
  registerTask,
  registerConnect,
  registerSetting,
  registerConfluence,
  registerDistributary,
  registerExclusiveGateway,
} from '@/components/Admin/Flow/bpmn/registerNode'
import {toTurboData} from "@/components/Admin/Flow/bpmn/Util/AdpterForTurbo";
import Http from "@/components/Admin/Flow/common/Http";
import FlowSheet from "./lib/FlowSheet";
import FlowPathPanel from "./LFComponents/FlowPathPanel";

export default {
  name: 'BpmnEditorComponents',
  components: {FlowPathPanel, NodePanel, AddPanel, Control, PropertyDialog },
  props:{
    sheet_id:{
      type:String|Number,
      default() {
        return null;
      }
    }
  },
  model:{
    prop:"sheet_id",
    event:"success"
  },
  data () {
    return {
      lf: null,
      showAddPanel: false,
      addPanelStyle: {
        top: 0,
        left: 0
      },
      nodeData: null,
      addClickNode: null,
      clickNode: null,
      dialogVisible: false,
      graphData: null,
      dataVisible: false,
      config: {
        background: {
          backgroundColor: '#f7f9ff',
        },
        grid: {
          size: 10,
          visible: false
        },
        keyboard: {
          enabled: true,
          shortcuts: [
            {
              keys: ["backspace"],
              callback: () => {
                const r = window.confirm("确定要删除吗？");
                if (r) {
                  const elements = this.lf.getSelectElements(true);
                  this.lf.clearSelectElements();
                  elements.edges.forEach((edge) => this.lf.deleteEdge(edge.id));
                  elements.nodes.forEach((node) => this.lf.deleteNode(node.id));
                }
              }
            }
          ]
        },
        edgeTextDraggable: true,
        hoverOutline: true,
      },
      moveData: {},
      nodeList,
      show_flow_sheet_status:false,
      form:{
        name:"",
        image:"",
        graph_data:"",
      },
      host_url:"",
      uploadUrl:"",
      bpmn_id:"",
      flow_path:[],
      dataVisible2:false,
    }
  },
  mounted () {
    this.host_url=Http.getBaseURL();
    this.uploadUrl=this.host_url+"/flow/UserRole/uploadFile";
    this.$_initLf()
    this.onInit();
  },
  watch:{
    sheet_id(n){
      this.onInit();
    }
  },
  methods: {
    onInit(){
      this.bpmn_id=this.sheet_id;
      if(this.bpmn_id){
        this.getData(this.bpmn_id);
      }else {
        this.form={
          name:"",
          image:"",
          graph_data:"",
        };
        this.lf.render();
      }
    },
    $_initLf () {
      // 画布配置
      const lf = new LogicFlow({
        ...this.config,
        plugins: [
          Menu,
          MiniMap,
          Snapshot,
          ContextPad,
        ],
        container: this.$refs.container,
      })
      this.lf = lf
      window.lf=lf;
      setContextPad(lf);
      // setDndPanel(lf);
      // 设置主题
      lf.setTheme({
        circle: {
          stroke: '#000000',
          strokeWidth: 1,
          outlineColor: '#88f',
        },
        rect: {
          outlineColor: '#88f',
          strokeWidth: 1
        },
        polygon: {
          strokeWidth: 1
        },
        polyline: {
          stroke: '#000000',
          hoverStroke: '#000000',
          selectedStroke: '#000000',
          outlineColor: '#88f',
          strokeWidth: 1
        },
        nodeText: {
          color: '#000000'
        },
        edgeText: {
          color: '#000000',
          background: {
            fill: '#f7f9ff'
          }
        },
      })
      this.$_registerNode()
    },
    // 自定义
    $_registerNode () {
      registerStart(this.lf)
      registerUser(this.lf)
      registerEnd(this.lf)
      registerPush(this.lf, this.clickPlus, this.mouseDownPlus)
      registerDownload(this.lf)
      registerPolyline(this.lf)
      registerTask(this.lf)
      registerConnect(this.lf)
      registerSetting(this.lf)
      registerConfluence(this.lf)
      registerDistributary(this.lf)
      registerExclusiveGateway(this.lf)
      this.$_render()
    },
    $_render () {
      this.lf.render()
      this.$_LfEvent()
    },
    $_getData () {
      const data = this.lf.getGraphData()
      console.log(JSON.stringify(data))
    },
    $_LfEvent () {
      var that=this;
      that.lf.on('node:click', ({data}) => {
        console.log('node:click', data)
        that.$data.clickNode = data
        that.$data.dialogVisible = false
        that.$nextTick(ret=>{
          that.$data.dialogVisible = true
        })
      })
      that.lf.on('edge:click', ({data}) => {
        console.log('edge:click', data)
        that.$data.clickNode = data
        that.$data.dialogVisible = false
        that.$nextTick(ret=>{
          that.$data.dialogVisible = true
        })
      })
      that.lf.on('element:click', () => {
        that.hideAddPanel()
      })
      that.lf.on('edge:add', ({data}) => {
        // console.log('edge:add', data)
      })
      that.lf.on('node:mousemove', ({data}) => {
        // console.log('node:mousemove')
        that.moveData = data
      })
      that.lf.on('blank:click', (e) => {
        console.log(e)
        that.hideAddPanel()
      })
      that.lf.on('connection:not-allowed', (data) => {
        that.$message({
          type: 'error',
          message: data.msg
        })
      })
      that.lf.on('node:mousemove', () => {
        // console.log('on mousemove')
      })
    },
    clickPlus (e, attributes) {
      e.stopPropagation()
      console.log('clickPlus', e, attributes)
      const { clientX, clientY } = e
      console.log(clientX, clientY)
      this.$data.addPanelStyle.top = (clientY - 40) + 'px'
      this.$data.addPanelStyle.left = clientX + 'px'
      this.$data.showAddPanel = true
      this.$data.addClickNode = attributes
    },
    mouseDownPlus (e, attributes) {
      e.stopPropagation()
      console.log('mouseDownPlus', e, attributes)
    },
    hideAddPanel () {
      this.$data.showAddPanel = false
      this.$data.addPanelStyle.top = 0
      this.$data.addPanelStyle.left = 0
      this.$data.addClickNode = null
    },
    closeDialog () {
      // this.$data.dialogVisible = false
    },
    $_catData(){
      this.$data.graphData = this.$data.lf.getGraphData();
      this.$data.dataVisible = true;
    },
    $_catTurboData(){
      const graphData = this.$data.lf.getGraphData();
      // 数据转化为Turbo识别的数据结构
      this.$data.graphData = toTurboData(graphData)
      this.$data.dataVisible = true;
    },
    $_onEventControl(btn_type){
      var that=this;
      if(btn_type==='flow_path'){
        that.getFlowPath();
      }else if(btn_type==='save'){
        that.saveFlowSheet();
      }
    },
    saveFlowSheet(){
      const that = this;
      let f_data=JSON.parse(JSON.stringify(that.form));
      f_data.graph_data=JSON.stringify(that.$data.lf.getGraphData());
      that.lf.extension.snapshot.getSnapshotBase64().then(({data, width, height}) => {
        Http.post("/flow/FlowSheet/uploadBase64", {base64:data},ret=>{
          if(ret.code){
            f_data.image=ret.data
            // f_data.id=undefined;//去了这里就是新增
            Http.post("/flow/FlowSheet/save",f_data,ret=>{
              if(ret.code){
                that.form=ret.data;
                that.bpmn_id=ret.data.id;
                that.$emit("success",that.bpmn_id)
                that.$message.success('保存成功')
              }else {
                that.$message.error(ret.msg||"保存失败")
              }
            })
          }else {
            that.$message.error(ret.msg||"保存失败")
          }
        })

      })

    },
    importData(text){
      console.log(text)
    },
    getData(id){
      const that = this;
      Http.get("/flow/FlowSheet/get",{
        id:id
      },ret=>{
        if(ret.code){
          try {
            ret.data.graph_data=JSON.parse(ret.data.graph_data)
            that.lf.render(ret.data.graph_data);
          }catch (e) {
            ret.data.graph_data={}
            that.lf.render();
          }

          that.form=ret.data
        }else {
          that.$message.error(ret.msg||"导入失败")
        }
      })
    },
    getFlowPath(){
      const that = this;
      let graph_data=that.$data.lf.getGraphData();
      let fs=new FlowSheet(graph_data);
      window.fs=fs;
      that.flow_path=fs.getAllNodeSequenceList();
      that.dataVisible2=true;
    }
  }
}
</script>
<style lang="scss">
@import "../common";
.logic-flow-view {
  height: calc( 100vh - 100px );
  width: calc( 100vw - 150px );
  position: relative;

  .panel-property{
    position: absolute;
    width: 400px;
    right: 5px;
    top: 50px;
    background-color: #FFFFFF;
  }
}
.demo-control{
  position: absolute;
  top: 5px;
  right: 0;
  left: 0;
  margin: 0 auto;
  z-index: 2;
  display: inline-table;
}
#LF-view{
  width: 100%;
  height: 100%;
  outline: none;
  //margin-left: 50px;
}
.add-panel {
  position: absolute;
  z-index: 11;
  background-color: white;
  padding: 10px 5px;
}
.el-drawer__body {
  height: 80%;
  overflow: auto;
  margin-top: -30px;
  z-index: 3;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Flow/bpmn/BpmnEditorComponents.vue